import React from "react"

const Habmburger = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
    >
      <circle cx="22" cy="22" r="22" fill="#DAECE4" />
      <path
        d="M30.25 21.2495H13.75C13.3358 21.2495 13 21.5853 13 21.9995C13 22.4137 13.3358 22.7495 13.75 22.7495H30.25C30.6642 22.7495 31 22.4137 31 21.9995C31 21.5853 30.6642 21.2495 30.25 21.2495Z"
        fill="#2B4346"
        stroke="#2B4346"
        strokeWidth="0.25"
      />
      <path
        d="M30.25 16H13.75C13.3358 16 13 16.3358 13 16.75C13 17.1642 13.3358 17.5 13.75 17.5H30.25C30.6642 17.5 31 17.1642 31 16.75C31 16.3358 30.6642 16 30.25 16Z"
        fill="#2B4346"
        stroke="#2B4346"
        strokeWidth="0.25"
      />
      <path
        d="M30.25 26.4998H13.75C13.3358 26.4998 13 26.8355 13 27.2498C13 27.664 13.3358 27.9998 13.75 27.9998H30.25C30.6642 27.9998 31 27.664 31 27.2498C31 26.8355 30.6642 26.4998 30.25 26.4998Z"
        fill="#2B4346"
        stroke="#2B4346"
        strokeWidth="0.25"
      />
    </svg>
  )
}

export default Habmburger
